module.exports = "<a href=\"https://rule.se\">\n    <img  class=\"img\" alt=\"logo\" src=\"/img/logo-full.svg\"/>\n</a>\n";